module.exports = __webpack_public_path__ + "img/logo.00d39e16.png";